{
  "_vgBinding": "vg-binding: CONTEXT:decisions=P17.D-25,P17.D-26,P17.D-33,P17.D-41,P17.D-42,P17.D-45,P17.D-47 INTERFACE-STANDARDS:error-shape — complete vendorRouting namespace (page shell + 4 tabs + dialogs + fence report + typed error codes keyed by error.code) owned by task-28; waves 9-11 consume t() only [task-28]",
  "nav": {
    "routing": "Routing"
  },
  "page": {
    "title": "Vendor routing",
    "subtitle": "Scoring weights, merchant rules, blueprint preferences and the location-fence report.",
    "placeholder": {
      "weights": "Scoring weights are not available on this screen yet.",
      "merchantRules": "Merchant routing rules are not available on this screen yet.",
      "preferences": "Blueprint routing preferences are not available on this screen yet.",
      "fenceReport": "The location-fence report is not available on this screen yet."
    }
  },
  "tabs": {
    "weights": "Weights",
    "merchantRules": "Merchant rules",
    "preferences": "Preferences",
    "fenceReport": "Fence report"
  },
  "forbidden": {
    "title": "Access denied",
    "description": "You need the assignment-rules permission to open vendor routing. Ask an administrator to grant it.",
    "home": "Back to home"
  },
  "common": {
    "retry": "Retry",
    "cancel": "Cancel",
    "save": "Save",
    "close": "Close",
    "loading": "Loading…",
    "na": "N/A"
  },
  "weights": {
    "live": {
      "heading": "Live weights",
      "versionLabel": "Version {{version}}",
      "configSource": {
        "document": "From the saved configuration",
        "fallback_default": "From the shipped defaults"
      }
    },
    "fallbackDefault": "No saved configuration was found, so the engine is running on the shipped defaults. Routing works normally; propose a set to replace them.",
    "axis": {
      "rating": "Rating",
      "utilization": "Utilization",
      "sla": "SLA",
      "cost": "Cost",
      "preferenceEpsilon": "Preference epsilon"
    },
    "costShadowNote": "The cost axis is at 0 on purpose: the score is computed and recorded, but it changes no pick until a proposal raises the weight.",
    "epsilonHint": "Ships at 0, so only vendors with exactly equal scores are grouped together. Raise it to let near-equal scores share a group before preferences apply.",
    "pending": {
      "heading": "Pending proposal",
      "proposedBy": "Proposed by",
      "proposedAt": "Proposed at",
      "reason": "Reason",
      "diffLive": "Live",
      "diffProposed": "Proposed"
    },
    "pendingBlocksPropose": "A proposal is already waiting for a decision. Only one can be open at a time — approve, reject or cancel it first.",
    "selfApprovalDisabled": "You proposed this set, so a second administrator has to approve it.",
    "cancelOwnerOnly": "Only the administrator who proposed a set can cancel it.",
    "propose": {
      "heading": "Propose a new set",
      "sumLabel": "Total of the four axes",
      "epsilonLabel": "Preference epsilon (not counted in the total)",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "Why should these weights change?",
      "submit": "Submit proposal"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "cancel": "Cancel proposal",
      "revert": "Restore this set"
    },
    "revert": {
      "reasonPrefill": "Restore the weights that were live before version {{version}}."
    },
    "approve": {
      "title": "Approve these weights?",
      "noteLabel": "Note (optional)",
      "confirm": "Approve and activate"
    },
    "reject": {
      "title": "Reject this proposal",
      "reasonLabel": "Reason",
      "reasonRequired": "A reason is required — it is the record of why the change was refused.",
      "reasonPlaceholder": "Explain what is wrong with the proposed set.",
      "confirm": "Reject proposal"
    },
    "cancel": {
      "title": "Cancel your proposal",
      "noteLabel": "Note (optional)",
      "confirm": "Cancel proposal"
    },
    "history": {
      "heading": "Activation history",
      "empty": "No set has been activated yet. The engine is running on the current live weights.",
      "version": "Version",
      "activatedAt": "Activated at",
      "activatedBy": "Activated by",
      "proposedBy": "Proposed by"
    },
    "toast": {
      "proposed": "Proposal sent. It is waiting for a second administrator.",
      "approved": "Weights approved and now live.",
      "rejected": "Proposal rejected. The live weights are unchanged.",
      "cancelled": "Proposal cancelled. The live weights are unchanged."
    },
    "unknownAdmin": "Admin no longer exists"
  },
  "rules": {
    "heading": "Merchant routing rules",
    "table": {
      "merchant": "Merchant",
      "blockedCount": "Blocked",
      "allowedCount": "Allowed",
      "updatedAt": "Updated at",
      "updatedBy": "Updated by",
      "actions": "Actions"
    },
    "filters": {
      "searchLabel": "Search",
      "searchPlaceholder": "Merchant name or id",
      "sortLabel": "Sort by"
    },
    "sort": {
      "updatedAtDesc": "Newest update first",
      "updatedAtAsc": "Oldest update first",
      "merchantNameAsc": "Merchant name A→Z",
      "merchantNameDesc": "Merchant name Z→A"
    },
    "empty": {
      "title": "No merchant has routing rules yet",
      "description": "This list only shows merchants that already have a rules document. Nothing is broken — pick a merchant to write the first set."
    },
    "actions": {
      "add": "Add rules",
      "edit": "Edit",
      "save": "Save rules",
      "removeVendor": "Remove vendor"
    },
    "editor": {
      "title": "Routing rules",
      "blockedLabel": "Blocked vendors",
      "allowedLabel": "Allowed vendors",
      "vendorPickerPlaceholder": "Search a vendor to add",
      "merchantPickerLabel": "Merchant"
    },
    "badge": {
      "inactive": "Inactive",
      "missing": "No longer exists"
    },
    "semantics": {
      "blockWins": "A blocked vendor stays blocked even when it also appears in the allowed list.",
      "allowNarrows": "A non-empty allowed list narrows routing to exactly those vendors — everyone else is out.",
      "emptyPoolManual": "If these rules leave no vendor, the item is held for manual assignment instead of going somewhere unexpected."
    },
    "conflict": {
      "heading": "Someone else saved first",
      "body": "Your edits are still here and nothing has been written yet. Choose whether to apply them on top of the newer version, or to drop them and start from what is now stored.",
      "unreadable": "The server could not read its own stored rules for this merchant, so the current lists are not shown. Saving will overwrite that document — check with whoever last changed it first.",
      "retry": "Keep my edits and save again",
      "discard": "Discard mine and reload theirs",
      "changedBy": "Changed by",
      "changedAt": "Changed at"
    },
    "toast": {
      "saved": "Routing rules saved."
    }
  },
  "preferences": {
    "heading": "Blueprint routing preferences",
    "blueprintLabel": "Blueprint",
    "pickBlueprint": "Pick a blueprint to see and edit its vendor order.",
    "default": {
      "heading": "Blueprint default"
    },
    "overrides": {
      "heading": "Variant overrides"
    },
    "table": {
      "rank": "Rank",
      "vendor": "Vendor",
      "actions": "Actions"
    },
    "actions": {
      "moveUp": "Move up",
      "moveDown": "Move down",
      "remove": "Remove from ranking",
      "addOverride": "Add a variant override",
      "removeOverride": "Remove this override",
      "save": "Save preferences"
    },
    "empty": {
      "title": "No preferences set",
      "description": "Nothing is wrong: with no ranking, this blueprint routes on pure score order."
    },
    "clearedToScoreOrder": "Saved. This blueprint has no ranking left, so routing is back to pure score order.",
    "limits": {
      "afterFilters": "Preferences apply only after these stages have run: {{steps}}.",
      "topScoreGroupOnly": "They reorder only the vendors inside the top-score group — never a lower-scoring vendor above a higher one.",
      "neverAllocation": "They never touch allocation percentages: a split keeps exactly the share the administrator typed."
    },
    "stage": {
      "merchant_rules": "Merchant rules",
      "location_fence": "Location fence",
      "rejected": "Rejected vendors",
      "hard_filter": "Hard filters",
      "scoring": "Scoring"
    },
    "override": {
      "title": "Add a variant override",
      "variantLabel": "Variant",
      "allTaken": "Every variant on this blueprint already has an override.",
      "removeConfirm": "Remove the override for {{variant}}? The variant will fall back to the blueprint default."
    },
    "badge": {
      "inactive": "Inactive",
      "missing": "No longer exists",
      "variantMissing": "Variant no longer exists"
    },
    "duplicateVendor": "This vendor is already in the ranking. Each vendor can appear once.",
    "conflict": {
      "heading": "Someone else saved first",
      "body": "Nothing was written — the save is all-or-nothing, so one out-of-date section stops the whole thing. Your edits are still here.",
      "retry": "Keep my edits and save again",
      "discard": "Discard mine and reload theirs"
    },
    "toast": {
      "saved": "Preferences saved."
    }
  },
  "fence": {
    "heading": "Location-fence report",
    "mode": {
      "label": "Fence mode",
      "workerReported": "Reported by the routing worker",
      "heartbeatAt": "Last heartbeat",
      "gitSha": "Build",
      "pid": "Worker PID",
      "staleWarning": "The worker has not reported recently, so this mode may be out of date.",
      "neverReported": "No worker has ever reported a fence mode, so the real mode is unknown. This screen will not guess.",
      "off": "Off",
      "log": "Log only",
      "enforce": "Enforcing",
      "unknown": "Unknown"
    },
    "filters": {
      "fromLabel": "From",
      "toLabel": "To",
      "locationLabel": "Location",
      "allLocations": "All locations",
      "blueprintLabel": "Blueprint",
      "allBlueprints": "All blueprints"
    },
    "coveredRange": {
      "label": "Range covered",
      "truncated": "Events are kept for {{ttlDays}} days, so the start of your range has already expired."
    },
    "summary": {
      "totalEvents": "Fence events",
      "topScoreChanged": "Top pick changed",
      "distinctOrders": "Orders affected",
      "distinctVariants": "Variants affected",
      "distinctLocations": "Locations affected",
      "topExcludedVendors": "Most excluded vendors"
    },
    "table": {
      "heading": "Fence events",
      "occurredAt": "Occurred at",
      "location": "Location",
      "blueprintVariant": "Blueprint / variant",
      "order": "Order",
      "excludedVendors": "Excluded vendors",
      "poolBefore": "Pool before",
      "poolAfter": "Pool after",
      "poolDiffHint": "These two counts are how many vendors were eligible, not how many were picked.",
      "topScoreChanged": "Top pick changed"
    },
    "empty": {
      "modeOff": "The fence is switched off, so no events are expected here.",
      "logNoEvents": "The fence is running and found nothing to change in this range."
    },
    "drift": {
      "heading": "Allocations outside their binding",
      "explain": "These splits send work to a vendor the location binding does not cover. Nothing is repaired from this screen — fix them where allocations are edited.",
      "openAllocations": "Open vendor allocations",
      "table": {
        "variant": "Variant",
        "location": "Location",
        "vendor": "Vendor",
        "weightPct": "Share",
        "enabled": "Enabled",
        "reason": "What is wrong"
      },
      "reason": {
        "VENDOR_NOT_IN_BINDING": "A binding exists at this location but leaves this vendor out — correct the allocation, or widen the binding.",
        "NO_BINDING_FOR_LOCATION": "The variant binds nothing at all at this location — create the binding."
      },
      "empty": "No allocation points outside its binding."
    },
    "ruleViolating": {
      "heading": "Assignments that today's rules would refuse",
      "explain": "A rule change never re-routes work that was already assigned. This list is informational: nothing here is moved automatically, and any correction is a human decision.",
      "empty": "Nothing live contradicts a current rule.",
      "assignedAt": "Assigned at",
      "ruleUpdatedAt": "Rule changed at",
      "table": {
        "order": "Order",
        "merchant": "Merchant",
        "variant": "Variant",
        "vendor": "Vendor",
        "violation": "Why it would be refused"
      },
      "violation": {
        "MERCHANT_BLOCKED": "The merchant now blocks this vendor.",
        "NOT_IN_ALLOWLIST": "The merchant's allowed list no longer includes this vendor.",
        "OUTSIDE_LOCATION_BINDING": "The location binding no longer covers this vendor."
      }
    },
    "priceSkew": {
      "heading": "Split groups with a wide cost spread",
      "explain": "The engine honours the shares you typed, whatever they cost. This list only shows you where a split is expensive so you can decide whether to change it.",
      "minCost": "Lowest cost",
      "maxCost": "Highest cost",
      "spread": "Spread",
      "costHidden": "Cost amounts are hidden for your account. This split is flagged because its prices are far apart.",
      "undeclaredCount": "{{count}} vendors have not declared a cost",
      "empty": "No split group has a cost spread worth flagging."
    },
    "enable": {
      "heading": "How to switch the fence on",
      "alreadyEnforcing": "The fence is already enforcing. Nothing to change here."
    },
    "enableSteps": {
      "1": "Set {{envVar}} to {{targetMode}} in the environment of both services.",
      "2": "Restart {{first}} first — the worker has to enforce before anything reports that it does.",
      "3": "Then restart {{second}}.",
      "4": "Come back to this report and check that the mode banner reads {{targetMode}}."
    },
    "completeness": {
      "unrepresentable": "{{count}} assignment(s) match a rule but cannot be shown: they were created before this report's data existed and carry no variant reference. This list does not cover them — an empty list here is not proof there is no exposure.",
      "scanLimitReached": "Only the {{limit}} most recent open assignments were examined. A rule written today exposes older ones, so anything beyond that window is not counted here.",
      "truncated": "Showing {{returned}} of {{matched}}. The rest are cut by the page ceiling, not resolved."
    }
  },
  "reasons": {
    "NO_VENDOR_MATCH": "No vendor matched this item, so it is waiting for a manual assignment.",
    "BLOCKED_BY_MERCHANT_RULE": "The merchant's own routing rules left no eligible vendor, so the item is waiting for a manual assignment.",
    "NO_VENDOR_FOR_LOCATION": "No vendor is bound to this location for this variant, so the item is waiting for a manual assignment.",
    "MERCHANT_RULES_UNAVAILABLE": "The merchant's routing rules could not be read, so the item was held rather than routed on a guess. This is a system fault, not a rule the merchant set — check the service before editing any rules.",
    "VENDOR_LOCATION_FROZEN": "Every vendor for this location is frozen by an admin, so the item is waiting for a manual assignment. Unfreeze one on the vendor's Locations tab, or assign by hand."
  },
  "errors": {
    "ROUTING_WEIGHTS_SUM_INVALID": "The four axes must add up to 1. Adjust them and submit again.",
    "ROUTING_WEIGHTS_PENDING_EXISTS": "Another proposal reached the slot first. Yours was not sent — decide the pending one, then try again.",
    "ROUTING_WEIGHTS_NO_PENDING": "There is no proposal waiting any more — someone decided it while this page was open.",
    "ROUTING_WEIGHTS_SELF_APPROVAL": "You proposed this set, so you cannot approve it. Ask a second administrator.",
    "ROUTING_WEIGHTS_STALE_PROPOSAL": "The proposal you were looking at is no longer the one waiting. Nothing was decided — read the current proposal below before acting.",
    "ROUTING_WEIGHTS_CANCEL_FORBIDDEN": "Only {{owner}} can cancel this proposal. You can still approve or reject it.",
    "MERCHANT_ROUTING_RULE_CONFLICT": "The same vendor is in both the blocked and the allowed list. Nothing was saved — remove it from one side.",
    "MERCHANT_ROUTING_RULE_VENDOR_INVALID": "One of these ids has never been a vendor. Nothing was saved — remove it and try again.",
    "MERCHANT_ROUTING_RULE_VERSION_CONFLICT": "Someone saved these rules while you were editing. Your edits are kept — choose how to continue.",
    "MERCHANT_NOT_FOUND": "That merchant no longer exists.",
    "ROUTING_PREFERENCE_VERSION_CONFLICT": "Someone saved these preferences while you were editing. Nothing was written and your edits are kept — choose how to continue.",
    "ROUTING_PREFERENCE_VENDOR_INVALID": "One of these ids has never been a vendor. Nothing was saved — remove it and try again.",
    "BLUEPRINT_NOT_FOUND": "That blueprint no longer exists.",
    "ALLOCATION_VENDOR_NOT_IN_LOCATION_BINDING": "This split sends work to a vendor the location binding does not cover. Nothing was saved — fix the allocation, or widen the binding first.",
    "MERCHANT_RULES_UNAVAILABLE": "The merchant's routing rules could not be read. This is a system fault, not a rule — nothing about the rules needs changing.",
    "VALIDATION_FAILED": "Some fields are invalid. Please review the highlighted ones and try again.",
    "UNAUTHENTICATED": "Please sign in to continue.",
    "FORBIDDEN": "You do not have permission to do this.",
    "INTERNAL_ERROR": "Something went wrong on our side. Please try again.",
    "NETWORK": "Could not reach the server — check your connection and try again.",
    "GENERIC": "Something went wrong. Please try again."
  }
}
